import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { RefreshCw, TriangleAlert } from 'lucide-react';
import { Button, Card, EmptyState } from '@proerp/ui';
import { clearReloadFlag, isChunkLoadError, shouldReloadOnce } from '@/lib/chunkError';

/**
 * Fehlergrenze des Routers. Wichtigster Fall: Nach einem Deploy fordert ein
 * noch offener Client einen alten Chunk-Hash an — der Lazy-Import wirft.
 * Dann laden wir die Seite EINMAL automatisch neu (frisches index.html);
 * für alle anderen Fehler gibt es eine erklärende Seite mit Neu-laden-Knopf.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const isStaleChunk = isChunkLoadError(error);

  useEffect(() => {
    if (isStaleChunk && shouldReloadOnce(window.sessionStorage)) {
      window.location.reload();
    }
  }, [isStaleChunk]);

  return (
    <div className="flex min-h-svh items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md">
        <EmptyState
          icon={TriangleAlert}
          title={isStaleChunk ? 'Neue Version verfügbar' : 'Da ist etwas schiefgelaufen'}
          description={
            isStaleChunk
              ? 'Die Anwendung wurde aktualisiert. Die Seite wird neu geladen …'
              : 'Die Ansicht konnte nicht geladen werden. Bitte lade die Seite neu — bleibt der Fehler bestehen, melde dich beim Admin.'
          }
          action={
            <Button variant="primary" onClick={() => window.location.reload()}>
              <RefreshCw strokeWidth={1.5} />
              Neu laden
            </Button>
          }
        />
      </Card>
    </div>
  );
}

/** Beim erfolgreichen Start das Heil-Flag freigeben (nächster Deploy darf wieder neu laden). */
export function ChunkReloadReset() {
  useEffect(() => {
    clearReloadFlag(window.sessionStorage);
  }, []);
  return null;
}
